import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["createCard", "menuCard"]

  connect() {
    this.handleResize = this.syncCreateCardHeight.bind(this)
    this.handleCollapseChange = this.syncCreateCardHeight.bind(this)

    window.addEventListener("resize", this.handleResize)
    this.element.addEventListener("shown.bs.collapse", this.handleCollapseChange)
    this.element.addEventListener("hidden.bs.collapse", this.handleCollapseChange)

    this.syncCreateCardHeight()
  }

  disconnect() {
    window.removeEventListener("resize", this.handleResize)
    this.element.removeEventListener("shown.bs.collapse", this.handleCollapseChange)
    this.element.removeEventListener("hidden.bs.collapse", this.handleCollapseChange)
  }

  syncCreateCardHeight() {
    if (!this.hasCreateCardTarget) return

    const createCardRowTop = this.createCardTarget.offsetTop
    const rowCards = this.menuCardTargets.filter((card) => this.sameRow(card.offsetTop, createCardRowTop))
    const collapsedCards = rowCards.filter((card) => !this.cardExpanded(card))
    const candidates = collapsedCards.length > 0 ? collapsedCards : rowCards
    const maxHeight = candidates.reduce((height, card) => Math.max(height, card.offsetHeight), 0)

    if (maxHeight > 0) {
      this.createCardTarget.style.minHeight = `${maxHeight}px`
    }
  }

  cardExpanded(card) {
    return (
      card.querySelector(".menu-cards2-availability-collapse.show") !== null ||
      card.querySelector(".menu-cards2-warning-collapse.show") !== null
    )
  }

  sameRow(cardTop, rowTop) {
    return Math.abs(cardTop - rowTop) < 8
  }
}
